import React from "react";
import { Space, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import PageLayout from "../../components/layout/PageLayout/PageLayout";
import ModelValidationDatasetsPage from "./ModelValidationDatasetsPage";
import ModelValidationRulesPage from "./ModelValidationRulesPage";
import ModelEvaluationV3Section from "./modelValidation/ModelEvaluationV3Section";

const WORKSPACE_ROUTES = {
    datasets: "/admin/model-management/validation-datasets",
    evaluations: "/admin/model-management/evaluations",
    rules: "/admin/model-management/validation-rules",
} as const;

type WorkspaceTab = keyof typeof WORKSPACE_ROUTES;

const getActiveWorkspaceTab = (pathname: string): WorkspaceTab => {
    if (pathname.startsWith(WORKSPACE_ROUTES.datasets)) {
        return "datasets";
    }
    if (pathname.startsWith(WORKSPACE_ROUTES.rules)) {
        return "rules";
    }
    return "evaluations";
};

const ModelEvaluationWorkspacePage: React.FC = () => {
    const { t } = useTranslation(["admin", "navigation"]);
    const location = useLocation();
    const navigate = useNavigate();
    const activeTab = getActiveWorkspaceTab(location.pathname);

    return (
        <PageLayout
            title={t("admin:modelManagement.sections.evaluations")}
            breadcrumb={[
                { title: t("navigation:breadcrumb.modelManagement") },
                { title: t("admin:modelManagement.sections.evaluations") },
            ]}
        >
            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                <Tabs
                    activeKey={activeTab}
                    onChange={(key) =>
                        navigate(WORKSPACE_ROUTES[key as WorkspaceTab])
                    }
                    items={[
                        {
                            key: "evaluations",
                            label: t("admin:modelValidation.evaluations.title"),
                            children: <ModelEvaluationV3Section />,
                        },
                        {
                            key: "datasets",
                            label: t("admin:modelValidation.datasets.title"),
                            children: <ModelValidationDatasetsPage embedded />,
                        },
                        {
                            key: "rules",
                            label: t("admin:modelValidation.rules.title"),
                            children: <ModelValidationRulesPage embedded />,
                        },
                    ]}
                />
            </Space>
        </PageLayout>
    );
};

export default ModelEvaluationWorkspacePage;
